import { Flex } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { useTitle } from '../../../../hooks/useTitle'
import { ProfileSection } from './sections/ProfileSection'
import { VerifyAccountSection } from './sections/VerifyAccountSection'
import { DeleteAccountSection } from './sections/DeleteAccountSection'


export function AccountScreen() {
  const { t } = useTranslation('translation', { keyPrefix: 'settings.account' })

  // Document title
  useTitle(t('title'))

  return (
    <Flex gap={8} direction="column">

      <VerifyAccountSection />

      <ProfileSection />

      <DeleteAccountSection />

    </Flex>
  )
}
